import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8deb7924a0efb63/src/layout/home/homeContent.tsx");
